export enum KycRejectionHeader
{
    CustomerInformation = 0,
    CustomerLoadEstimate = 1,
    BuildingOwnerInformation = 2,
    AccountInformation = 3,
    MeterRequest = 4,
    ServicePointData = 5,
    DocumentUpload = 6
}

export enum KycRejectedImage
{
    Signature = 0,
    LandlordsSignature = 1,
    ElectricalContractorsSignature = 2,
    ApplicantsSignature = 3,
    ApplicantsPassportPhotograph = 4,
    NinCard = 5,
    ProofOfOwnership = 6,
    LetterOfConsent = 7,
    TenancyAgreement = 8
}

export enum KycRejectedField
{
    FirstName = 'FirstName',
    Surname = 'Surname',
    OwnershipStatus = 'OwnershipStatus',
    BuildingOwnersName = 'BuildingOwnersName',
    ServiceType = 'ServiceType',
    SubServiceType = 'SubServiceType',
    CustomerType = 'CustomerType',
    ClientType = 'ClientType',
    IdentificationType = 'IdentificationType',
    PersonalIdNumber = 'PersonalIdNumber',
    Region = 'Region',
    Area = 'Area',
    UseOfPremise = 'UseOfPremise',
    Geolocation = 'Geolocation'
}

export class Rejection {
    rejectedPage: KycRejectionHeader;
    reason: string;
    rejectedImages: KycRejectedImage[];
    rejectedFields: string[];
    stepNumber: number;

    constructor(data: any) {
        this.rejectedPage = data?.rejectedPage;
        this.reason = data?.reason;
        this.rejectedImages = data?.rejectedImages ?? null;
        this.rejectedFields = data?.rejectedFields ?? null;
        this.stepNumber = data?.stepNumber
    }
}